import { Pipe, PipeTransform } from '@angular/core';
import { SupportedLanguage } from '@workspace/data-types';

@Pipe({
  name: 'languageLabel',
})
export class LanguageLabelPipe implements PipeTransform {
  transform(value: SupportedLanguage): string {
    const map: Record<SupportedLanguage, string> = {
      'fr-FR': 'Français',
      'en-US': 'English',
      'de-DE': 'Deutsch',
    };

    return map[value] ?? value;
  }
}
